import { Injectable } from "@nestjs/common";
import { EducationDTO } from "./education.dto";
import { Education } from "../education.entity";

@Injectable()
export class EducationAdapter{

    public convertDtoToEntity(dto: EducationDTO, isUpdate: boolean = false): Education{
        const entity = new Education();
        entity.educationId = dto.educationId;
        entity.education = dto.education;
        entity.isActive = dto.isActive;
        if(isUpdate){
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: Education): EducationDTO{
        const dto = new EducationDTO;
        dto.educationId = entity.educationId;
        dto.education = entity.education;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        return dto;
    }
}